import React from "react"
import { retrieveItemImageFromHero } from "../utilities"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbRte from "../ui-kit/dfb_rte"
import DfbButton from "../ui-kit/dfb_button"
import DfbImage from "../ui-kit/dfb_image"
import Section from "./section"

import { Transformation } from "cloudinary-react"

const MHighlightTeaser = (props) => {
  let data = {}
  let collection = props.data.collection
  if (collection && collection[0]) {
    if (props.data.find_item_image) {
      collection = retrieveItemImageFromHero(collection)
    }
    data = collection[0]

    data.image = data.content.titleimage
    if (data.content.categories && data.content.categories[0]) {
      data.kicker = data.content.categories[0].title
    }
    data.subtitle = `<p>${data.content.subtitle}</p>`
    data.headline = data.content.title
    data.link = data.full_slug
    data.link_text = "Zu dem Beitrag"
    data.anchor_name = props.data.anchor_name
  } else {
    data = props.data
  }

  return (
    <Section baseClass="m-HighlightTeaser" defaultPadding="large" data={data}>
      {data.image && data.image.src && (
        <div className="dfb-Image dfb-Image--3To1Ration dfb-Image--cover dfb-Image--lazyloading dfb-Image--overlay dfb-Image--opacity55 m-HighlightTeaser-img">
          <DfbImage
            image={data.image}
            aspect_ratio="3:1"
            overlay="55"
            add_class="dfb-Image-image"
          >
            <Transformation
              crop="fill"
              gravity="faces:center"
              width="1920"
              height="637"
              quality="auto"
              fetchFormat="auto"
            />
          </DfbImage>
        </div>
      )}
      <div className="m-HighlightTeaser-wrapper">
        <div className="m-HighlightTeaser-container">
          {data.kicker && (
            <div className="m-HighlightTeaser-category">{data.kicker}</div>
          )}
          {data.headline && (
            <DfbHeadline
              headline={data.headline}
              headline_level="h3"
              add_class="u-Theme-dark m-HighlightTeaser-headline"
            />
          )}
          {data.text && (
            <DfbRte
              text={data.text}
              add_class={`u-Theme-dark${
                data.headline || data.link_text || data.kicker
                  ? " m-HighlightTeaser-subhead"
                  : ""
              }`}
            />
          )}
          {data.link_text && (
            <div className="m-HighlightTeaser-button">
              <DfbButton
                tagName="a"
                text={data.link_text}
                link={data.link}
                link_obj={data.link_obj}
                add_class="u-Theme-dark"
              />
            </div>
          )}
        </div>
      </div>
    </Section>
  )
}

export default MHighlightTeaser
